import React from 'react';

const CardIcon = ({ strokeColor = "#001489" }) => {
    return (
       <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
           <path d="M5.55796 9.76296L5.27096 8.69595C4.98196 7.62695 5.61696 6.52795 6.68696 6.24295L16.73 3.56695C17.79 3.28495 18.89 3.91996 19.176 4.97896L20.93 11.488C21.218 12.557 20.582 13.656 19.514 13.941L17.4 14.504" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
           <path fillRule="evenodd" clipRule="evenodd" d="M5 20.5007H15.4C16.505 20.5007 17.4 19.6057 17.4 18.5007V11.7637C17.4 10.6587 16.505 9.76367 15.4 9.76367H5C3.895 9.76367 3 10.6587 3 11.7637V18.5007C3 19.6057 3.896 20.5007 5 20.5007Z" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
           <path d="M3 13.8398H17.4" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
       </svg>
    );
};

export default CardIcon;

